import axios from "axios";
import type { AxiosInstance } from "axios";

// Ensure VITE_API_BASE_URL exists in your environment
const baseURL: string = import.meta.env.VITE_API_BASE_URL;

const api: AxiosInstance = axios.create({
  baseURL,
  paramsSerializer: {
    indexes: null, // serialize arrays as ?foo=1&foo=2 instead of ?foo[]=1&foo[]=2
  },
});

// Add response interceptor for un-wrapping data and 401 error handling
api.interceptors.response.use(
  (response) => {
    // Check if response matches the standard backend wrapper format
    if (
      response.data && 
      typeof response.data === 'object' && 
      'success' in response.data && 
      'data' in response.data && 
      'code' in response.data
    ) {
      // For endpoints that need the total count (pagination)
      if (response.data.pagination) {
        // If data is an array, we can attach total to it, or wrap it in a way the frontend expects.
        // Many frontend tables expect { data: [], total: X } if paginated
        response.data = {
          data: response.data.data,
          total: response.data.pagination.total || response.data.pagination.count || 0
        };
      } else {
        // Otherwise just unwrap the raw data
        response.data = response.data.data;
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear all auth data from localStorage
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("is_admin");
      localStorage.removeItem("crediflow_user");
      
      // Check if this was a token refresh failure (likely AFK timeout)
      const isRefreshFailure = error.config?.url?.includes('/auth/refresh/');
      
      // Redirect to login page with AFK reason if it was a refresh failure
      const redirectUrl = isRefreshFailure ? "/login?reason=afk" : "/login";
      window.location.href = redirectUrl;
    }
    return Promise.reject(error);
  }
);

export default api;

